import { useMemo } from "react";

import { useProductionGroups } from "@/hooks/production-groups";
import { useCartonPropertyGroups } from "@/hooks/carton-property-groups";

import { type AssignedProductionGroups, CartonPropertyGroupsTemplate } from "./carton-property-groups.template";

export const CartonPropertyGroups = () => {
	const { data, isLoading, isFetchedAfterMount, error, refetch } = useCartonPropertyGroups();
	const { productionGroups } = useProductionGroups();

	const assignedProductionGroups = useMemo<AssignedProductionGroups>(() => {
		const productionGroupData = productionGroups ?? [];

		return data.reduce<AssignedProductionGroups>((acc, val) => {
			if (
				productionGroupData.length === 0 ||
				val.assignedToProductionGroups === undefined ||
				val.assignedToProductionGroups.length === 0
			)
				return acc;

			const names = val.assignedToProductionGroups
				.map((id) => {
					const pg = productionGroupData.filter((m) => m.id === id);
					return pg.length > 0 ? pg[0].alias : "";
				})
				.filter((v) => v !== "");

			names.sort();
			acc[val.id] = names.join(", ");
			return acc;
		}, {});
	}, [data, productionGroups]);

	return (
		<CartonPropertyGroupsTemplate
			cartonPropertyGroups={data}
			assignedProductionGroups={assignedProductionGroups}
			isLoading={isLoading || isFetchedAfterMount === false}
			isError={Boolean(error)}
			onRetry={refetch}
		/>
	);
};
